import './DownloadPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import Content from 'components/Content';

import { updateTitle } from 'containers/App/store/actions';

class DownloadPage extends React.Component {
    componentWillMount() {
        document.body.classList.add('download-page');
        this.props.updateTitle('Download');
    }

    componentWillUnmount() {
        document.body.classList.remove('download-page');
    }

    render() {
        return (
            <Content>
                Download the PinPoint client app from iTunes or the Google Play store.<br />
                <Link to="/logout">Click here to sign out</Link>
            </Content>
        )
    }
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateTitle: (title) => dispatch(updateTitle(title))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DownloadPage);



// WEBPACK FOOTER //
// ./src/containers/DownloadPage/index.js